import React from 'react';
import { useTabsNavigationStore, GAME_TABS_CONFIG } from '../../../stores';

// .tabs-view — под-табы выбранной игры (Вопросы/Санкции/Управление/…).
// В новой верстке живут в области контента, а не в шапке.
export default function GameSubTabs() {
    const selectedGame = useTabsNavigationStore(state => state.selectedGame);
    const selectedGameTab = useTabsNavigationStore(state => state.selectedGameTab);
    const setGameTab = useTabsNavigationStore(state => state.setGameTab);

    const tabs = selectedGame ? GAME_TABS_CONFIG[selectedGame] : null;
    if (!tabs || tabs.length === 0) return null;

    return (
        <div className="tabs-view">
            {tabs.map(tab => (
                <button
                    type="button"
                    key={tab.id}
                    className={selectedGameTab === tab.id ? 'on' : undefined}
                    onClick={() => setGameTab(tab.id)}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
}
